module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Standard-4.53098b29.png";